module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', [_vm._v("Dedication")]), _vm._v(" "), _c('p', [_vm._v("You suddenly appeared and I pulled you close, such a blubbering wreck as I kissed your nose, and later that day I wrote a letter to you, the contents of which I now haven’t a clue, but soon you will read for the year is near, my emotional writings to you my dear")]), _vm._v(" "), _c('p', [_vm._v("Ellie,")]), _vm._v(" "), _c('p', [_vm._v("Colourful lots xxx")]), _vm._v(" "), _c('p', [_vm._v("To Lewey Lee, Squeezebox and Gibbs,")]), _vm._v(" "), _c('p', [_vm._v("Just file this next to my CD, or you could even read it.")]), _vm._v(" "), _c('p', [_vm._v("To Avril,")]), _vm._v(" "), _c('p', [_vm._v("True, it’s not your cup of coffee, but give it a stir sometime, you never know…xx")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2100e44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch003.vue
// module id = 69
// module chunks = 0